import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { RouletteScene } from "./RouletteScene";
import { RouletteManager } from "./RouletteManager";
import { GameManager } from "../../GameManager";

export class LowerContainer extends Phaser.GameObjects.Container {

    private static GOLD_GLOW_POSITIONS = [
        {x: -160, y: -40},
        {x: -120, y: -65},
        {x: 50, y: 65},
        {x: 70, y: -65}
    ];

    private spinBtn: Phaser.GameObjects.Image
    private stopBtn: Phaser.GameObjects.Image
    private infoBtn: Phaser.GameObjects.Image;
    private audioBtn: Phaser.GameObjects.Image;
    private f: number;
    private goldGlow: Phaser.GameObjects.Image;
    private container1: Phaser.GameObjects.Container;
    private container2: Phaser.GameObjects.Container;
    private stopPressed: boolean;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.f = 0;
        this.stopPressed = false;
        this.stopBtn = null;

        this.container1 = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, 0);
        this.add(this.container1);

        let sideButtons_px: number;

        if (GameVars.aspectRatio < 1.65) {

            this.container1.y = GameConstants.GAME_HEIGHT - 150 * GameVars.scaleY;
            this.container1.scaleX = .8;
            this.container1.scaleY = .8 * GameVars.scaleY;
            sideButtons_px = 600;
            
        } else {

            this.container1.y = GameConstants.GAME_HEIGHT - 250 * GameVars.scaleY;
            this.container1.scaleY = GameVars.scaleY;
            sideButtons_px = 440;
        }

        this.infoBtn = new Phaser.GameObjects.Image(this.scene, -sideButtons_px, 0, "texture_atlas_1", "btn_info");
        this.infoBtn.setInteractive();
        this.infoBtn.on("pointerover", () => {
            this.infoBtn.setScale(1.05);
        }, this);

        this.infoBtn.on("pointerout", () => {
            this.infoBtn.setScale(1);
        }, this);

        this.infoBtn.on("pointerdown", () => {
            this.onClickInfo();
        }, this);
        this.container1.add(this.infoBtn);

        if (GameVars.spinsCounter > 0) {
            this.spinBtn = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_spin");
            this.spinBtn.setInteractive();
            this.spinBtn.on("pointerover", () => {
                this.spinBtn.setScale(1.05);
            }, this);
    
            this.spinBtn.on("pointerout", () => {
                this.spinBtn.setScale(1);
            }, this);
    
            this.spinBtn.on("pointerdown", () => {
                this.spinBtn.setScale(1.05);
                this.onClickSpinButton();
            }, this);
    
            this.spinBtn.on("pointerup", () => {
                this.spinBtn.setScale(1);
            }, this);
    
            this.container1.add(this.spinBtn);
        } else {
            this.spinBtn = null;
        }

        this.audioBtn = new Phaser.GameObjects.Image(this.scene, sideButtons_px, 0, "texture_atlas_1", "btn_audio_on");
        this.audioBtn.setInteractive();
        this.audioBtn.on("pointerover", () => {
            this.audioBtn.setScale(1.05);
        }, this);

        this.audioBtn.on("pointerout", () => {
            this.audioBtn.setScale(1);
        }, this);

        this.audioBtn.on("pointerdown", () => {
            this.onClickAudio();
        }, this);
        this.container1.add(this.audioBtn);

        if (this.scene.sound.mute) {
            this.audioBtn.setFrame("btn_audio_off")
        } else {
            this.audioBtn.setFrame("btn_audio_on")
        }

        this.goldGlow = new Phaser.GameObjects.Image(this.scene, 70, -65, "texture_atlas_1", "gold_glare");
        this.goldGlow.visible = false;
        this.container1.add(this.goldGlow);

        // EL CONTENEDOR 2 CON UN BOTON DE BACK PARA CUANDO SE MUESTRA EL PREMIO
        this.container2 = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 180 * GameVars.scaleY);
        this.container2.visible = false;
        this.add(this.container2);

        const backButton = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_back");
        backButton.setInteractive();
        backButton.scaleY = GameVars.scaleY;
        backButton.on("pointerover", () => {
            backButton.setScale(1.05, 1.05 * GameVars.scaleY);
        }, this);

        backButton.on("pointerout", () => {
            backButton.setScale(1, GameVars.scaleY);
        }, this);

        backButton.on("pointerdown", () => {
            backButton.setScale(1.05, 1.05 * GameVars.scaleY);
        }, this);

        backButton.on("pointerup", () => {
            backButton.setScale(1);
            GameManager.enterRouletteScene();
            this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
        }, this);
        this.container2.add(backButton);
    }

    public update(): void {

        this.f ++;

        if (this.f === 225) {
            this.f = 75;
            this.goldShine();
        }
    }

    public showStopButton(): void {

        this.stopBtn = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_stop");
        this.stopBtn.setInteractive();
        this.stopBtn.on("pointerover", () => {
            this.stopBtn.setScale(1.05);
        }, this);

        this.stopBtn.on("pointerout", () => {
            this.stopBtn.setScale(1);
        }, this);

        this.stopBtn.on("pointerdown", () => {
            this.stopBtn.setScale(1.05);
            this.onClickStopButton();
        }, this);

        this.stopBtn.on("pointerup", () => {
            this.stopBtn.setScale(1);
        }, this);

        this.stopBtn.setScale(.8);
        this.stopBtn.alpha = 0;

        this.scene.add.tween({
            targets: this.stopBtn,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });

        this.container1.add(this.stopBtn);

        this.goldGlow.visible = false;
        this.container1.bringToTop(this.goldGlow);

        this.scene.time.delayedCall(7000, function(): void {
            if (!this.stopPressed && this.scene) {
                this.onClickStopButton(true);
            }
        }, [], this);  
    }

    public onPrizeShown(): void {

        this.scene.add.tween({
            targets: this.container1,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            onComplete: function(): void{
                this.container1.visible = false;
            },
            onCompleteScope: this
        });

        this.container2.visible = true;
        this.container2.alpha = 0;

        this.scene.add.tween({
            targets: this.container2,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            delay: 350
        });
    }

    private onClickInfo(): void {

        if (RouletteScene.currentInstance.roulette.spinning) {
            return;
        }
        
        GameManager.enterInfoScene();

        this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
    }

    private onClickSpinButton(): void {

        if (this.f < 10) {
            return;
        }

        this.spinBtn.visible = false;
        this.goldGlow.visible = false;

        RouletteManager.currentInstance.spin();

        this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
    }

    private onClickStopButton(automatic?: boolean): void {

        this.goldGlow.visible = false;

        this.stopPressed = true;
        this.stopBtn.disableInteractive();

        this.scene.add.tween({
            targets: this.stopBtn,
            scaleX: .8,
            scaleY: .8,
            alpha: 0,
            duration: 350,
            onComplete: function(): void {
                this.stopBtn.visible = false;
            },
            onCompleteScope: this
        });

        RouletteManager.currentInstance.stop();

        if (typeof automatic === "undefined") {
            this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
        }
    }

    private onClickAudio(): void {

        this.scene.sound.mute = !this.scene.sound.mute;
            
        if (!this.scene.sound.mute) {
            this.audioBtn.setFrame("btn_audio_off")
        } else {
            this.audioBtn.setFrame("btn_audio_on")
        }

        this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
    }

    private goldShine(): void {

        if (this.stopPressed || !this.spinBtn || (!this.spinBtn.visible && this.stopBtn === null)) {
            return;
        }
    
        const i = Math.floor(Math.random() * LowerContainer.GOLD_GLOW_POSITIONS.length);

        this.goldGlow.x = LowerContainer.GOLD_GLOW_POSITIONS[i].x;
        this.goldGlow.y = LowerContainer.GOLD_GLOW_POSITIONS[i].y;

        this.goldGlow.visible = true;
        this.goldGlow.setScale(0);
        this.goldGlow.angle = 0;

        this.scene.add.tween({
            targets: this.goldGlow,
            scaleX: 5.5,
            scaleY: 5.5,
            angle: Math.random() > .5 ? -30 : 30,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 750,
            yoyo: true,
            onComplete: function(): void {
                this.goldGlow.visible = false;
            },
            onCompleteScope: this
        });
    }
}
